module.exports = __webpack_public_path__ + "images/DefaultFieldTrial_01_929a3aa2e93a747da451f70c9e38a69e.jpeg";